var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyDescriptionActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.35693 11.0833V2.91667C2.35693 2.27233 2.88019 1.75 3.52567 1.75H11.1225C11.4452 1.75 11.7068 2.01117 11.7068 2.33333V9.33333C11.7068 9.6555 11.4452 9.91667 11.1225 9.91667H3.52567C2.88019 9.91667 2.35693 10.439 2.35693 11.0833V11.0833C2.35693 11.7277 2.88019 12.25 3.52567 12.25H11.7068",
    stroke: "#20E290",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5383 12.2493V9.91602",
    stroke: "#20E290",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36928 4.66667H4.69434",
    stroke: "#20E290",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36928 7.00065H4.69434",
    stroke: "#20E290",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyDescriptionActive);
export default __webpack_public_path__ + "static/media/company_description_active.132d38a2b75dd61559e1656b431a02a7.svg";
export { ForwardRef as ReactComponent };